<div class="c-loader__wrapper">
  <div class="c-loader c-loader--small">
    <i class="fa fa-spinner" aria-hidden="true"></i>
  </div>
</div>
<div class="c-loader__content">
  <ng-content></ng-content>
</div>
<div class="c-loader__output">
  <i class="fa fa-check" aria-hidden="true"></i>
  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
</div>
